/** @flow */
import User from 'common/domain/user';
import UserProfileAPI from 'common/modules/userProfile/services/UserProfileAPI';
import type { Dispatch, GetState } from '../../../redux/types/redux';
import { getToken, getUser } from '../../authentication/selectors/sessionSelectors';

export const UPDATE_PROFILE = 'userProfile/UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'userProfile/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'userProfile/UPDATE_PROFILE_FAILURE';

export function updateProfile(userProfile: Object) {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: UPDATE_PROFILE });
    try {
      const token = getToken(getState());

      await UserProfileAPI.updateProfile(token, userProfile);

      // TODO - Enlever le parse lorsqu'on aura immutable parce qu'actuellement updateUserProfile modifie pas la ref. du RadioUser
      let user = getUser(getState());
      user.setUserProfile(userProfile);
      user = User.parse(user);

      dispatch({ type: UPDATE_PROFILE_SUCCESS, userProfile: userProfile });
    } catch (error) {
      dispatch({ type: UPDATE_PROFILE_FAILURE, error: error });
    }
  };
}



// WEBPACK FOOTER //
// ./src/advertisers/modules/userProfile/actions/userProfileActions.js